import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
import _typeof from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.sort";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bpmnHeadStastic, bpmnChatStastic, bpmnPageServeStastic, bpmnPageDeptStastic, bpmnStuAndteachStastic, bpmnByTimesStastic, exportServeStastic } from "@/api/bpmnApi/bpmn";
import DateComponent from "@/components/public/DateComponent";
import detailShow from "@/views/statistical/all/detailShow";
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "all",
  components: {
    DateComponent: DateComponent,
    TreeSelect: TreeSelect,
    detailShow: detailShow
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      headJson: {},
      chartJson: {},
      curTab: "serve",
      List: [],
      pageSizes: [10, 20, 30, 50, 100],
      headLoading: false,
      pieLoading: false,
      tableLoading: false,
      leftLoading: false,
      rightLoading: false,
      total: 0,
      stasticParams: {
        current: 1,
        size: 20,
        beginTime: "",
        endTime: ""
      },
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      departmentData: [],
      type: "0",
      deptId: ""
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getBpmnHeadStastic();
    this.getBpmnChatStastic();
    var arr = this.$refs.date.getValueStr();
    this.stasticParams.beginTime = arr[0];
    this.stasticParams.endTime = arr[1];
    this.initPage();
    this.getBpmnStuAndteachStastic();
    this.getBpmnByTimesStastic();
    this.getDeptTreeData();
  },
  destroyed: function destroyed() {},
  methods: {
    exportByServerOrDept: function exportByServerOrDept() {
      var _this = this;

      var path;
      path = this.curTab == "serve" ? "/admin/bpmn/stastics/exportServeStastic" : "/admin/bpmn/stastics/exportDeptStastic";
      this.$DownLoadL(path + "?" + this.$qs.stringify(this.stasticParams), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    openDetail: function openDetail(item) {
      this.$refs.detailShow.dialogShow(item, this.stasticParams, this.curTab);
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.deptId = data.id;
      this.getBpmnStuAndteachStastic();
    },
    getDeptTreeData: function getDeptTreeData() {
      var _this2 = this;

      getDeptTree().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this2.departmentData = data.data[0].children;
            } else {
              _this2.departmentData = data.data;
            }
          }
        }
      }).catch(function (err) {});
    },
    // 条数
    changeSize: function changeSize(value) {
      this.stasticParams.size = value;
      this.stasticParams.current = 1;
      this.initPage();
    },
    // 翻页
    changePage: function changePage(value) {
      this.stasticParams.current = value;
      this.initPage();
    },
    setTabHandle: function setTabHandle(text) {
      this.curTab = text;
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.total = 0;
      this.initPage();
    },
    setRightEchart: function setRightEchart(data, subtext, id) {
      data.sort(function (t1, t2) {
        return t1.cnt - t2.cnt;
      });

      if (data.length > 3) {
        data = data.slice(data.length - 3, data.length);
      }

      var labelList = data.map(function (i) {
        return i.serveName || "";
      });
      var numList = data.map(function (i) {
        return i.cnt;
      });
      var dom = document.getElementById(id);
      var myChart = this.echarts.init(dom);
      var myColor = ["#4979BC", "#EDBBD5", "#1FAF92"];
      var option = {
        // title: {
        //     subtext:subtext,      //副标题
        //     subtextStyle:{          //对应样式
        //         color :'#6B6B6B',
        //         fontWeight :'700',
        //         fontSize :'14'
        //     }
        // },
        title: {
          text: subtext,
          padding: [10, 35, 0, 200],
          textStyle: {
            color: "#6B6B6B",
            fontWeight: "700",
            fontSize: "12"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "5%",
          right: "4%",
          bottom: 0,
          top: 35,
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          show: false
        },
        yAxis: {
          type: "category",
          data: labelList,
          axisTick: {
            show: false
          },
          axisLine: {
            //y轴
            show: false
          }
        },
        series: [{
          name: "次数",
          barWidth: 8,
          //设置柱子宽度
          type: "bar",
          data: numList,
          itemStyle: {
            normal: {
              label: {
                formatter: "{c}" + "次",
                show: true,
                position: "right",
                textStyle: {
                  fontSize: "12",
                  color: "#ccc"
                }
              },
              color: function color(params) {
                var index = params.dataIndex;
                var num = myColor.length;
                return myColor[index % num];
              }
            }
          }
        }]
      };

      if (option && _typeof(option) === "object") {
        myChart.setOption(option, true);
      }
    },
    setLeftEchart: function setLeftEchart(data) {
      var labelList = data.map(function (i) {
        return i.name || "";
      });
      var dealNumList = data.map(function (i) {
        return i.dealNum;
      });
      var applyNumList = data.map(function (i) {
        return i.applyNum;
      });
      var dom = document.getElementById("echartsLeftLine");
      var myChart = this.echarts.init(dom);
      var option = {
        title: {
          text: "服务趋势",
          padding: [10, 35, 0, 20],
          textStyle: {
            color: "#6B6B6B",
            fontWeight: "700",
            fontSize: "14"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["服务次数", "服务人数"],
          bottom: 10 //legend距离canvas上面的距离

        },
        grid: {
          left: "10%",
          width: "80%",
          containLabel: false
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: labelList
        },
        yAxis: {
          name: "数量"
        },
        series: [{
          name: "服务次数",
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#81D3CB"
          },
          color: "#81D3CB",
          data: applyNumList
        }, {
          name: "服务人数",
          type: "line",
          smooth: true,
          color: "#99ACFF",
          lineStyle: {
            color: "#99ACFF"
          },
          data: dealNumList
        }]
      };

      if (option && _typeof(option) === "object") {
        myChart.setOption(option, true);
      }
    },
    setChart: function setChart(data) {
      var lineColor = ["#7E74F8", "#D97AE1", "#F0755E"];
      var deptColor = ["#3560E5", "#436BE7", "#5276E9", "#6182EB", "#6F8DEC", "#7D99EE", "#8BA4F0", "#9AAFF2", "#A9BBF4", "#32DFA0", "#64E7B7", "#9AAFF2"];
      var depts = (data.depts || []).map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          name: i.deptName,
          value: i.all
        });
      });
      var line = [];
      (data.line || []).forEach(function (i) {
        if (Number(i.cnt) > 0) {
          line.push({
            name: i.name,
            value: i.cnt
          });
        }
      });
      var dom = document.getElementById("echartsPie");
      var myChart = this.echarts.init(dom);
      var option = {
        tooltip: {
          trigger: "item",
          formatter: function formatter(params, cell) {
            var obj = params.data;

            if (cell.indexOf("dept") == -1) {
              return "";
            }

            return "".concat(obj.name, "  (").concat(params.percent, "% \u5168\u90E8\uFF1A").concat(obj.all, ",\u7EBF\u4E0A \uFF1A").concat(obj.online, ",\u7EBF\u4E0B\uFF1A").concat(obj.offline, ",\u7EBF\u4E0A\u548C\u7EBF\u4E0B\uFF1A").concat(obj.onlineAndOffline, ")");
          }
        },
        series: [{
          type: "pie",
          selectedMode: "single",
          radius: [0, "36%"],
          label: {
            formatter: "{b}\n{c}",
            position: "inner"
          },
          labelLine: {
            show: false
          },
          data: line,
          itemStyle: {
            // emphasis: {
            //     borderWidth: 0,
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)',
            // },
            normal: {
              borderWidth: 2,
              borderColor: "#ffffff",
              color: function color(params) {
                var index = params.dataIndex;
                var num = lineColor.length;
                return lineColor[index % num];
              }
            }
          }
        }, {
          name: "dept",
          type: "pie",
          radius: ["44%", "58%"],
          label: {
            formatter: function formatter(params, cell) {
              var obj = params.data;
              return "".concat(obj.name, "  (").concat(params.percent, "%)");
            },
            color: "#999999",
            backgroundColor: "#fff",
            fontSize: 13,
            padding: [0, 7],
            rich: {
              a: {
                color: "#999",
                lineHeight: 22,
                align: "center"
              },
              hr: {
                backgroundColor: "#fff",
                width: "100%",
                borderWidth: 0.5,
                height: 0
              },
              b: {
                fontSize: 12,
                lineHeight: 20
              },
              per: {
                color: "#eee",
                backgroundColor: "#fff",
                padding: [2, 4],
                borderRadius: 2
              }
            }
          },
          data: depts,
          itemStyle: {
            normal: {
              borderWidth: 2,
              borderColor: "#ffffff",
              color: function color(params) {
                var index = params.dataIndex;
                var num = deptColor.length;
                return deptColor[index % num];
              }
            }
          }
        }]
      };

      if (option && _typeof(option) === "object") {
        myChart.setOption(option, true);
      }
    },
    getBpmnHeadStastic: function getBpmnHeadStastic() {
      var _this3 = this;

      this.headLoading = true;
      bpmnHeadStastic().then(function (_ref2) {
        var data = _ref2.data;
        _this3.headLoading = false;

        if (data.code == 0) {
          _this3.headJson = data.data || {};
        }
      }).catch(function (err) {
        _this3.headLoading = false;
      });
    },
    getBpmnChatStastic: function getBpmnChatStastic() {
      var _this4 = this;

      this.pieLoading = true;
      bpmnChatStastic().then(function (_ref3) {
        var data = _ref3.data;
        _this4.pieLoading = false;

        if (data.code == 0) {
          _this4.setChart(data.data);
        }
      }).catch(function (err) {
        _this4.pieLoading = false;
      });
    },
    initPage: function initPage() {
      var _this5 = this;

      this.tableLoading = true;
      var method = bpmnPageServeStastic;

      if (this.curTab == "dept") {
        method = bpmnPageDeptStastic;
      }

      method(this.stasticParams).then(function (_ref4) {
        var data = _ref4.data;
        _this5.tableLoading = false;

        if (data.code == 0) {
          if (data.data) {
            _this5.List = data.data.records;
            _this5.total = data.data.total;
          }
        } else {
          _this5.List = [];
          _this5.total = 0;
        }
      }).catch(function (err) {
        _this5.List = [];
        _this5.total = 0;
        _this5.tableLoading = false;
      });
    },
    getBpmnByTimesStastic: function getBpmnByTimesStastic() {
      var _this6 = this;

      this.leftLoading = true;
      var type = {
        type: this.type
      };
      bpmnByTimesStastic(_objectSpread(_objectSpread({}, this.stasticParams), type)).then(function (_ref5) {
        var data = _ref5.data;
        _this6.leftLoading = false;

        if (data.code == 0) {
          _this6.setLeftEchart(data.data || []);
        }
      }).catch(function (err) {
        _this6.leftLoading = false;
      });
    },
    getBpmnStuAndteachStastic: function getBpmnStuAndteachStastic() {
      var _this7 = this;

      this.rightLoading = true;
      var deptId = {
        deptId: this.deptId
      };
      bpmnStuAndteachStastic(_objectSpread(_objectSpread({}, this.stasticParams), deptId)).then(function (_ref6) {
        var data = _ref6.data;
        _this7.rightLoading = false;

        if (data.code == 0) {
          _this7.setRightEchart(data.data.teacher || [], "老师办理服务TOP3", "echartsRightTop");

          _this7.setRightEchart(data.data.stu || [], "学生办理服务TOP3", "echartsRightBottom");
        }
      }).catch(function (err) {
        _this7.rightLoading = false;
      });
    },
    searchPage: function searchPage() {
      var arr = this.$refs.date.getValueStr();
      this.stasticParams.beginTime = arr[0];
      this.stasticParams.endTime = arr[1];
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.type = 5;
      this.initPage();
      this.getBpmnStuAndteachStastic();
      this.getBpmnByTimesStastic();
    },
    handletime: function handletime(arr, value) {
      this.stasticParams.beginTime = arr[0];
      this.stasticParams.endTime = arr[1];
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.type = value;
      this.initPage();
      this.getBpmnStuAndteachStastic();
      this.getBpmnByTimesStastic();
    }
  },
  watch: {},
  filters: {}
};